import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconClipboardSignature",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, i, h, p, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--clipboard-signature"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Clipboard Signature",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...r[0] || (r[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.953 4.997a.55.55 0 0 0-.39.161L7.447 7.28l-.258 1.03 1.031-.261 2.122-2.113a.552.552 0 0 0-.178-.897.55.55 0 0 0-.21-.042Zm-.594-.882a1.55 1.55 0 0 1 1.69 2.529h-.001l-2.22 2.21a.5.5 0 0 1-.23.13l-1.975.5a.5.5 0 0 1-.608-.606l.495-1.975a.5.5 0 0 1 .131-.231l2.215-2.22c.144-.144.315-.259.503-.337ZM3.5 9a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.5 1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1H9a1.502 1.502 0 0 1 1.298.75.5.5 0 0 1-.866.5A.5.5 0 0 0 9 2.5h-.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1H3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-.25a.5.5 0 0 1 1 0V10A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10V3A1.5 1.5 0 0 1 3 1.5h.5Zm1 0h3v1h-3v-1Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=clipboard-signature.js.map
